import { myApi } from '../../config/axiosConfig';

// =========================================
// BUSCAR CORREOS
// =========================================

export const getCorreos = async () => {

    const response = await myApi.get('/emails');

    return response.data;

}